<template>
  <a :href="this.notification.data.sport_event_url" class="notification-item-wrap notification-item-progress">
    <div v-if="!!this.notification.sport_event_name" class="event-name">
      <a :href="this.notification.data.sport_event_url">
        {{ this.notification.sport_event_name }}
      </a>
    </div>

    <div class="notification-item">
      <div class="notification-item-message">
        <span v-html="renderMessage()"></span>
      </div>
    </div>
  </a>
</template>

<script>
  export default {
    props: {
      notification: Object,
    },
    data() {
      return {
      }
    },
    methods: {
      renderMessage() {
        return I18n.t(
          "sport_events.notifications.user_new_rank_percentage",
          {
            percentage: this.notification.data.percentage,
            new_rank: I18n.t(`common.ranks.${this.notification.data.new_rank}`)
          }
        )
      }
    }
  }
</script>

<style scoped>
</style>
